/**
 * Extrae el mensaje de error de una respuesta del backend.
 * El API usa `errorMsg` (CustomErrorResponse); algunos endpoints usan `message` o `error`.
 */
export const getApiErrorMessage = (error, fallback = 'Ocurrió un error inesperado') => {
    if (!error) {
        return fallback;
    }

    if (error.request && !error.response) {
        return 'No se pudo conectar con el servidor';
    }

    const headerMessage = error?.response?.headers?.['x-error-message'];
    if (headerMessage) {
        return headerMessage;
    }

    const data = error?.response?.data;
    if (!data) {
        return fallback;
    }
    if (error?.response?.status === 429) {
        return 'Demasiados cambios seguidos. Esperá unos segundos e intentá de nuevo.';
    }
    if (typeof data === 'string') {
        return data;
    }
    return data.errorMsg || data.message || data.error || fallback;
};

export const getApiErrorMessageAsync = async (error, fallback = 'Ocurrió un error inesperado') => {
    const data = error?.response?.data;
    const isBlobLike = data instanceof Blob || (data && typeof data.text === 'function');
    if (isBlobLike) {
        try {
            const text = await data.text();
            const parsed = JSON.parse(text);
            return parsed.errorMsg || parsed.message || parsed.error || fallback;
        } catch {
            return fallback;
        }
    }
    return getApiErrorMessage(error, fallback);
};
